const notifications = {
  name: 'notifications',
  state: { pushNotifications: [] },
  reducers: {
    onPushNotificationReceived: (state, pushNotification) => ({
      ...state,
      pushNotifications: [...state.pushNotifications, pushNotification],
    }),
  },
  messageListeners: {
    PUSH_NOTIFICATION({ payload }) {
      this.onPushNotificationReceived(payload);
    },
  },
};

/* eslint-disable */
const _contactMessage = {
  contactId: '3e6ff6203d0b9e6a8fa1da93ea0b08f1',
  id: 'm92ecd0cd8c5aa6c0f1e7d874935625e1',
  recipient: 'med-4bc16c064c163a8ede26c145953b4a75',
  sender: {
    id: 'pat-43073083198d30d167f6252b17443cc3',
    firstName: 'Dean',
    lastName: 'Winchester',
    meOrSurrogate: true,
  },
  text: 'dd',
  time: '2021-07-23T08:20:30.747Z',
};

const _sessionChatMessage = {
  id: 'mb21e8ab63f0e22fd834281556399151c',
  sender: 'pKKd5xw',
  sessionId: 's-ct-6FAK6yBOfemrHNwmdhS8XNUpvXw6lT2TeZFrjuqe',
  text: 'Test',
  time: '2021-07-23T08:21:32.656Z',
};

const _notification = {
  title: 'fullNameWithTitle + translate',
  body: 'text',
  icon: 'avatar',
  linkTarget: '/chat/:id'
}
/* eslint-enable */

export default notifications;
